import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";

import TODIS_FORM_GENERAL from "./form/GENERAL/iwwportsgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/iwwportstencompliance.js";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/iwwelegibilityproject.js";
import TODIS_FORM_INDICATORS from "./form/NIWWPORTS/indicators.js";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/IRAILS/status";
import { TODIS_FORM_FIELD, TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";

import { BsExclamationCircleFill } from "react-icons/bs";

const TODIS_FORM_IIWWPORTS = ({ errors, touched, status }) => {
    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm=""/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Description" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmDescDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsImpPmDescDTO.remarks" label="Remarks" name="iwwPortsImpPmDescDTO.remarks" disabled={status}/>
                            {errors.iwwPortsImpPmDescDTO && errors.iwwPortsImpPmDescDTO.remarks && touched.iwwPortsImpPmDescDTO && touched.iwwPortsImpPmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsImpPmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmStatusDTO"/>
            </Tab>
            <Tab eventKey="elegibilityproject" title="TEN-T Project ">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmEligiTentDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsImpPmEligiTentDTO.remarks" label="Remarks" name="iwwPortsImpPmEligiTentDTO.remarks" disabled={status}/>
                            {errors.iwwPortsImpPmEligiTentDTO && errors.iwwPortsImpPmEligiTentDTO.remarks && touched.iwwPortsImpPmEligiTentDTO && touched.iwwPortsImpPmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsImpPmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T Compliance">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmTentcompDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsImpPmTentcompDTO.remarks" label="Remarks" name="iwwPortsImpPmTentcompDTO.remarks"disabled={status} />
                            {errors.iwwPortsImpPmTentcompDTO && errors.iwwPortsImpPmTentcompDTO.remarks && touched.iwwPortsImpPmTentcompDTO && touched.iwwPortsImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Port traffic - forecasted" Label2="Port traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsImpPmPiDTO.remarks" label="Remarks" name="iwwPortsImpPmPiDTO.remarks" disabled={status}/>
                            {errors.iwwPortsImpPmPiDTO && errors.iwwPortsImpPmPiDTO.remarks && touched.iwwPortsImpPmPiDTO && touched.iwwPortsImpPmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsImpPmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="indicators" title="Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsImpPmIndicatorsDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsImpPmIndicatorsDTO.remarks" label="Remarks" name="iwwPortsImpPmIndicatorsDTO.remarks" disabled={status}/>
                            {errors.iwwPortsImpPmIndicatorsDTO && errors.iwwPortsImpPmIndicatorsDTO.remarks && touched.iwwPortsImpPmIndicatorsDTO && touched.iwwPortsImpPmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsImpPmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}
export default TODIS_FORM_IIWWPORTS;